<div class="schedule-export-dialog">
  <h2 mat-dialog-title>Schedule Filtered Export</h2>

  <mat-dialog-content>
    <form [formGroup]="form">
      <!-- Basic Info Section -->
      <div class="section">
        <h3>Export Details</h3>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter schedule name">
          <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
          <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Name is too long</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description (optional)</mat-label>
          <textarea matInput formControlName="description" rows="2" placeholder="Enter description"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Export Format</mat-label>
          <mat-select formControlName="exportFormat">
            <mat-option *ngFor="let format of exportFormats" [value]="format.value">
              {{format.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Filter Summary -->
      <div class="section info-section">
        <h3>Export Configuration</h3>
        <div class="info-box">
          <div class="info-row">
            <strong>Table:</strong>
            <span class="badge">{{data.tableType | uppercase}}</span>
          </div>
          <div class="info-row">
            <strong>Filters:</strong>
            <span>{{getFilterSummary()}}</span>
          </div>
          <div class="info-row">
            <strong>Columns:</strong>
            <span>{{getColumnSummary()}}</span>
          </div>
        </div>
      </div>

      <!-- Schedule Section -->
      <div class="section">
        <h3>Schedule</h3>

        <div class="preset-buttons">
          <button
            type="button"
            mat-stroked-button
            *ngFor="let preset of cronPresets.slice(0, 6)"
            (click)="onPresetSelected(preset.value)"
            class="preset-btn">
            {{preset.label}}
          </button>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cron Expression</mat-label>
          <input matInput formControlName="cronExpression" placeholder="0 9 * * *">
          <button mat-icon-button matSuffix (click)="validateCron()" type="button" matTooltip="Validate cron expression">
            <mat-icon>check_circle</mat-icon>
          </button>
          <mat-hint>5-field cron format: minute hour day month weekday</mat-hint>
          <mat-error *ngIf="form.get('cronExpression')?.hasError('required')">Cron expression is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Timezone</mat-label>
          <mat-select formControlName="timezone">
            <mat-option *ngFor="let tz of timezones" [value]="tz">
              {{tz}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="checkbox-row">
          <mat-checkbox formControlName="isActive">
            Start active (export will begin running on schedule)
          </mat-checkbox>
        </div>
      </div>

      <!-- More Presets (Collapsible) -->
      <mat-expansion-panel class="presets-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            More Schedule Presets
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="preset-buttons">
          <button
            type="button"
            mat-stroked-button
            *ngFor="let preset of cronPresets.slice(6)"
            (click)="onPresetSelected(preset.value)"
            class="preset-btn">
            {{preset.label}}
          </button>
        </div>
      </mat-expansion-panel>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="saving">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="saving || form.invalid">
      <mat-icon *ngIf="saving">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>
      <span *ngIf="!saving">Create Schedule</span>
      <span *ngIf="saving">Creating...</span>
    </button>
  </mat-dialog-actions>
</div>
